<div class="search" *ngIf="!tableLoading">
  <form>
    <eos-filter
      [immigrationCountry]="countryType"
      [filters]="filters"
      [form]="filterForm"
      [locationWiseAccess]="locationWiseAccess"
    ></eos-filter>

    <div class="filter-row-buttons m-0">
      <div class="row d-flex flex-justify-between mx-auto w-50">
        <div class="col">
          <button class="btn btn-primary" (click)="clear()">
            Clear filter
          </button>
        </div>
        <div class="col">
          <button
            eosDebounce
            class="btn btn-primary"
            (debounceClick)="filter()"
          >
            Search
          </button>
        </div>
        <div class="col">
          <button
            eosDebounce
            [disabled]="disableDownload"
            *ngIf="enableReport"
            class="btn btn-report"
            (debounceClick)="report()"
          >
            <span *ngIf="!disableDownload">Report</span>
            <span *ngIf="disableDownload" class="spinner m-3"></span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<div
  class="table-resp candid-table"
  *ngIf="tableLoading == null ? false : !tableLoading"
>
  <table class="table table-sm table-bordered fixed-table">
    <tr>
      <th *ngFor="let item of columnHeaders">
        <a (click)="sort(!data.sortParameters.reverse, item.header)"
          >{{ item.display }}
          <img
            *ngIf="
              data.sortParameters.reverse &&
              data.sortParameters.sortBy === item.header
            "
            src="design/images/filter.png"
            class="float-end mt-3"
          />
          <img
            *ngIf="
              !data.sortParameters.reverse &&
              data.sortParameters.sortBy === item.header
            "
            src="design/images/filter-up.png"
            class="float-end mt-3"
            style="transform: rotateX(180)"
          />
        </a>
      </th>
      <th class="text-center" width="100px">
        <a (click)="sort(!data.sortParameters.reverse, 'Status')"
          >Status
          <img
            *ngIf="
              data.sortParameters.reverse &&
              data.sortParameters.sortBy === 'Status'
            "
            src="design/images/filter.png"
            class="float-end mt-3"
          />
          <img
            *ngIf="
              !data.sortParameters.reverse &&
              data.sortParameters.sortBy === 'Status'
            "
            src="design/images/filter-up.png"
            class="float-end mt-3"
            style="transform: rotateX(180)"
          />
        </a>
      </th>
      <th width="100px">Action</th>
    </tr>
    <tr *ngFor="let profile of data.immigrationProfiles">
      <td *ngFor="let item of columnHeaders">
        <span [ngSwitch]="item.type">
          <span *ngSwitchCase="'text'">{{ profile[item.property] }}</span>
          <span *ngSwitchCase="'secondary'">
            <span *ngIf="profile[item.property] != null">
              {{ profile[item.property][item.secondary] }}
            </span>
          </span>
          <span *ngSwitchCase="'date'">{{
            profile[item.property] | date : "dd-MMM-yy"
          }}</span>

          <span *ngSwitchDefault>
            {{ profile[item.property] }}
          </span>
        </span>
      </td>

      <td>
        <span class="status" [ngClass]="profile.status.value">{{
          profile.status.displayText
        }}</span>
      </td>
      <td>
        <a
          href="javascript:void(0)"
          [routerLink]="getRedirectUrl(profile)"
          routerLinkActive="active"
          ngbTooltip="Edit"
        >
          <img src="design/images/edit.png" />
        </a>
        <a
          *ngIf="
            profile.status.value === ImmigrationStatusTypes.DRAFT && viewDelete
          "
          (click)="deleteCandidate(profile)"
          ngbTooltip="Delete"
        >
          <img src="design/images/delete.png" />
        </a>
        <a
          *ngIf="
            profile.status.value !== ImmigrationStatusTypes.DRAFT &&
            profile.status.value !== ImmigrationStatusTypes.PENDING &&
            profile.status.value !== ImmigrationStatusTypes.DECLINED &&
            profile.status.value !== ImmigrationStatusTypes.WITHDRAWN &&
            viewAction(profile)
          "
          href="javascript:void(0)"
          [routerLink]="getActivityRedirectUrl(profile)"
          routerLinkActive="active"
          ngbTooltip="List"
        >
          <img src="design/images/list.png" />
        </a>
        <!-- reset activity -->
        <!-- <a *ngIf="profile.status.value == ImmigrationStatusTypes.INPROCESS" href="javascript:void(0)" (click)="activityReset(profile)"
                 ngbTooltip="Reset List">
                <img src="design/images/reset.png" />
              </a> -->
        <!--withdraw option-->
        <a
          (click)="withdrawCandidate(profile)"
          *ngIf="
            profile.status.value !== ImmigrationStatusTypes.DRAFT &&
            profile.status.value !== ImmigrationStatusTypes.COMPLETED &&
            profile.status.value !== ImmigrationStatusTypes.WITHDRAWN &&
            (viewAction(profile) ||
              (profile.createdBy == ActiveUserEmpId &&
                profile.requestor &&
                profile.requestor.id == null) ||
              (profile.requestor &&
                profile.requestor.id == ActiveUserEmpId &&
                !isAdminEditProfileRole))
          "
          ngbTooltip="Withdraw"
        >
          <img src="design/images/withdraw-1.png" />
        </a>
        <!--copy option-->
        <a
          (click)="copyCandidate(profile)"
          *ngIf="
            (viewAction(profile) ||
              profile.createdBy == ActiveUserEmpId ||
              (profile.requestor && profile.requestor.id == ActiveUserEmpId)) &&
            !isAdminEditProfileRole
          "
          ngbTooltip="Copy Request"
        >
          <img src="design/images/copy-light.png" />
        </a>
        <a
          (click)="viewMilestone(profile)"
          ngbTooltip="View Milestone"
          *ngIf="
            profile.status.value !== ImmigrationStatusTypes.DRAFT &&
            profile.status.value !== ImmigrationStatusTypes.PENDING &&
            profile.status.value !== ImmigrationStatusTypes.DECLINED &&
            profile.status.value !== ImmigrationStatusTypes.WITHDRAWN
          "
        >
          <img src="design/images/calendar.png" />
        </a>
      </td>
    </tr>
  </table>
</div>
<div class="row" *ngIf="tableLoading == null ? false : !tableLoading">
  <div class="col-md popover-height">
    <ng-template #content>
      <div class="info">
        <strong>Status</strong>
        <ul>
          <li>
            <span class="status Draft">Draft</span>
            Applicable when the requestor is in the process of creating a new
            visa request and has not yet submitted the same.
          </li>
          <li>
            <span class="status Pending">Pending</span>
            Applicable when the requestor has submitted a new visa request and
            has not yet been accepted by the Immigration team.
          </li>
          <li>
            <span class="status ImmAccepted">Accepted</span>
            Applicable when the requestor has submitted a visa request and has
            been accepted by the Immigration team.
          </li>
          <li>
            <span class="status Declined">Declined</span>
            Applicable when the new visa request submitted by the requestor has
            been declined by the immigration team
          </li>
          <li>
            <span class="status inprogress">In process</span>
            Applicable when the Immigration team member has completed a task
            pertaining to the Immigration task list (can be any of the task in
            the list) for a visa request.
          </li>
          <li>
            <span class="status Approved">Approved</span>
            Applicable when visa has been approved by authorities
          </li>
          <li>
            <span class="status Rejected">Rejected</span>
            Applicable when visa has been rejected by authorities
          </li>
          <li>
            <span class="status Joined">Completed</span>
            Applicable when the Immigration consultant completes all the
            required activities related to a visa request and has marked the
            request as completed
          </li>
          <li>
            <span class="status Hold">On hold</span>
            Applicable when the Immigration team member updates the immigration
            status data field to hold.
          </li>
          <li>
            <span class="status ImmWithdrawn">Withdrawn</span>
            Applicable when the requestor withdrawn the request.
          </li>
        </ul>
      </div>
    </ng-template>

    <img src="design/images/info.png" [ngbPopover]="content" />
  </div>
  <div class="col-md">
    <div class="page-nav">
      <nav>
        <ul class="pagination pagination-sm gap-1 custome-pagination">
          <li class="page-item" [ngClass]="{ disabled: currentPage - 1 < 1 }">
            <a class="page-link" (click)="pageChange(1)">
              <span aria-hidden="true">&laquo;&laquo;</span>
            </a>
          </li>
          <li class="page-item" [ngClass]="{ disabled: currentPage - 1 < 1 }">
            <a
              class="page-link"
              (click)="pageChange(currentPage - 1)"
              aria-label="Previous"
            >
              <span aria-hidden="true">&laquo;</span>
            </a>
          </li>
          <li
            [ngClass]="{ active: pageNumber + i === currentPage }"
            class="page-item"
            *ngFor="let i of pages"
          >
            <a (click)="pageChange(pageNumber + i)" class="page-link">{{
              pageNumber + i
            }}</a>
          </li>
          <li
            class="page-item"
            [ngClass]="{ disabled: currentPage + 1 > totalPages }"
          >
            <a
              class="page-link"
              (click)="pageChange(currentPage + 1)"
              aria-label="Next"
            >
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
          <li
            class="page-item"
            [ngClass]="{ disabled: currentPage + 1 > totalPages }"
          >
            <a class="page-link" (click)="pageChange(totalPages)">
              <span aria-hidden="true">&raquo;&raquo;</span>
            </a>
          </li>
        </ul>
      </nav>     
      <select
        (change)="onSelectChanges()"
        [(ngModel)]="data.sortParameters.itemsPerPage"
        class="form-select form-select-sm w-auto"
      >
        <option *ngFor="let count of changeCount" [value]="count">
          {{ count }}
        </option>
      </select>
      <p>Per page</p>
    </div>
  </div>
</div>

<div *ngIf="tableLoading == null" class="row p-3">
  <div class="col text-center text-dark">
    <p class="h6 fw-bold text-muted">No Candidates to show!</p>
  </div>
</div>
